import { SET_CENTER, SET_SELECTED_AREAS, SET_POI_MARKERS, SET_MARKER_DATA, 
        SET_CITY_WARD_DATA, RESET_POI } from '../actions/types';

const initialState = { center : '', selectedAreas: [], poi_markers : [], hide_info_box : true, set_marker_data : {} };

export default (state = initialState, action)=>{
    switch(action.type){
        case SET_CENTER : {
            return {...state, center : action.payload }
        } 
        case SET_SELECTED_AREAS : {
            return { ...state, selectedAreas : action.payload}
        }
        case SET_POI_MARKERS: {
            return { ...state, poi_markers :state.poi_markers.concat(action.payload) }
        }
        case SET_MARKER_DATA: {
            return { ...state, set_marker_data : action.payload}
        }
        case SET_CITY_WARD_DATA: {
            return { ...state, ward_data: action.payload}
        }
        case RESET_POI: {
            return { ...state, poi_markers :[] }
        }
        default : {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/v3/reducers/mapReducer.js